import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { url, usa_states } from "../../../../configlink";
import { useSelector } from "react-redux";

export default function DropboxDetails() {
  let [data, setData] = useState({
    id: '',
    dropbox: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    pickup3: ''
  });

  const states = usa_states
	let adminUser = useSelector((state) => state.userAdmin.userAdmin)
	
  let [changedData, setChangedData] = useState({})

  let loc = useLocation()
  let id = loc.search.split('=')[1]
  
  useEffect(() => {
    if(id){
      getData(id)
    }
  }, []);

  function getData(x){
    console.log(x);
    try {
      fetch(`${url}/api/admin/dropbox_details?id=${x}`, {
		credentials: 'include',
		headers: {
			'acgt-admin': adminUser
		},
      })
          .then((res) => res.json())
          .then((data) => {
              console.log(data);
              if(data.message === 'success'){
                let state2 

                if(data.result.state !== null){
                    state2 = states.find((s) => s.value.toLowerCase() === data.result.state.toLowerCase())
                }
                else {
                    state2 = {value:'NA', label:'NA'}
                }
                // console.log("STATE2", state2);
                
                let data2 = {...data.result, state: state2? state2.value : "NA" }
                console.log(data2);
                
                setData(data2)
              }        
          })
          .catch(err => {
              console.error(err);  
          })
  } catch (error) {
      console.error(error);
      
  }
  }

  // console.log(changedData);

  function createDropbox(){
    console.log(changedData);

     if(Object.keys(changedData).length !== 0 && changedData?.dropbox !== undefined){
         try {
           fetch(`${url}/api/admin/createDropbox`,{
                   method:"POST",
                   credentials:'include',
                   headers:{
						"Content-Type": "application/json",
						'acgt-admin': adminUser
                   },
                   body: JSON.stringify(changedData)
               }
           )
               .then((res) => res.json())
               .then((data) => {
                   console.log(data);   
                   if(data.message === 'exists'){
                    alert("ID already exists")
                   }
                   else if(data.message === 'success'){
                       alert("Created successfully")     
                       setData({
                        id: '',
                        dropbox: '',
                        address: '',
                        address2: '',
                        city: '',
                        state: '',
                        zip: '',
                        pickup3: ''
                       })  
                       
                       window.close()               
                   }                 
               })
               .catch(err => {
                   console.error(err);  
               })
       } catch (error) {
           console.error(error);
           
       }
     }
     else {
        alert("Missing Info")
     }
  }

  function updateContent(){
    console.log(changedData, id);

    if(Object.keys(changedData).length !== 0){
      // console.log('not empty');
      try {
        fetch(`${url}/api/admin/edit_dropbox_details?id=${id}`,{
                method:"PUT",
                headers:{
					"Content-Type": "application/json",
					'acgt-admin': adminUser
                },
                credentials: 'include',
                body: JSON.stringify(changedData)
            }
        )
            .then((res) => res.json())
            .then((data) => {
                console.log(data);   
                if(data.message === 'success'){
                    alert("Updated successfully")                   
                }                 
            })
            .catch(err => {
                console.error(err);  
            })
    } catch (error) {
        console.error(error);
    }
    }
    else{
      alert("No changes made")  
    }
    
  }
  

  return (
    <>
    <div className='p-2'>
        <h1 className='text-2xl font-bold'>Dropbox Details</h1>
        <div className='border border-black p-2 text-[13px] flex flex-col gap-[5px]'>
            {id ?
            <div className='flex bg-gray-100 py-1 px-2'>
                <p className='min-w-[250px] '>Dropbox ID:</p>
                <p className='font-bold'>{id}</p>
            </div>
            :
            <div className='flex py-1 px-2'>
                <p className='min-w-[250px]'>Dropbox ID:</p>
                <input type="text" className='border border-black px-2 w-[250px]' 
                value={data.id} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        id: e.target.value
                    })
                    setData({...data, id:e.target.value})
                }}
                />             
            </div>
            }
            
            <div className='flex py-1 px-2'>
                <p className='min-w-[250px]'>Dropbox Name:</p>
                <input type="text" className='border border-black px-2 flex-1' 
                value={data.dropbox} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        dropbox: e.target.value
                    })
                    setData({...data, dropbox:e.target.value})
                }}
                />             
            </div>

            <div className='flex py-1 bg-gray-100 px-2'>
                <p className='min-w-[250px]'>Address:</p>
                <input type="text" className='border border-black px-2 flex-1' 
                value={data.address} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        address: e.target.value
                    })
                    setData({...data, address:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 px-2'>
                <p className='min-w-[250px]'>Address2:</p>
                <textarea 
                rows={4}
                className='border border-black px-2 flex-1' 
                value={data.address2} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        address2: e.target.value
                    })
                    setData({...data, address2:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 bg-gray-100 px-2'>
                <p className='min-w-[250px]'>City:</p>
                <input type="text" className='border border-black px-2 flex-1'
                value={data.city} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        city: e.target.value
                    })
                    setData({...data, city:e.target.value})
                }}
                />             
            </div>
            
            <div className='flex py-1 px-2'>
                <p className='min-w-[250px]'>State:</p>
                <select name="state" 
                id="state" 
                className='w-[150px] border border-black' 
                value={data.state} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        state: e.target.value
                    })
                    setData({...data, state:e.target.value})
                }}
                >  
				<option value={""} selected disabled>Select</option>
                {states.map((x, i) => (
                <option key={i} value={x.value}>
                  {x.label}
                </option>
              ))}
                </select>           
            </div>
            <div className='flex py-1 bg-gray-100 px-2'>
                <p className='min-w-[250px]'>Zip Code:</p>
                <input type="text" className='border border-black px-2  w-[250px]' 
                value={data.zip} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        zip: e.target.value
                    })
                    setData({...data, zip:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 bg-gray-100 px-2'>
                <p className='min-w-[250px]'>Pick Up Time:</p>
                <input type="text" className='border border-black px-2  w-[250px]' 
                value={data.pickup3} 
                onChange={(e) => {
                    setChangedData({
                        ...changedData, 
                        pickup3: e.target.value
                    })
                    setData({...data, pickup3:e.target.value})
                }}
                />             
            </div>
            

            {id ? 
            <div className='flex justify-center mt-8 text-[14px]'>
                <button 
                onClick={() => updateContent()}
                className='bg-[var(--color-primary-purple)] text-white border border-black px-2'> Update Dropbox</button>
            </div> :
            <div className='flex justify-center mt-8 text-[14px]'>
                <button 
                onClick={() => createDropbox()}
                className='bg-[var(--color-primary-purple)] text-white border border-black px-2'> Create Dropbox</button>
            </div> 
            }
        </div>

        {/* <div className='flex justify-center mt-8 text-[14px]'>
            <button 
            onClick={() => window.close()}
            className='bg-[var(--color-primary-purple)] text-white border border-black px-2'> Close Window</button>
        </div> */}
    </div>
    </>
    //  :
    //  <p className="p-2">Loading..</p>
    // }
    // </>
  );
}
